export {
  default,
  default as MeetingCardPlaceholder,
} from "./MeetingCardPlaceholder";
